import React, { useEffect, useState } from 'react'
import { useSocketService } from '@/context/SocketServiceContext'
import { default as ReactAvatar } from 'react-avatar'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle'
// eslint-disable-next-line @typescript-eslint/no-var-requires
const logo = require('@/images/xlab-logo.jpg')

import { Box } from '@mui/material'
import Kedo from '@/Kedo.js'

interface IAvatarOptions {
    togglePresence?: boolean
    size?: number
    showPresence?: boolean
}

interface User {
    userId: string | number
    username: string
}

interface AvatarProps {
    kedo: Kedo
    user: User
    props?: any
    onClick?: () => void
    options?: IAvatarOptions
    presence?: string
}

const Avatar: React.FC<AvatarProps> = ({
    kedo,
    user,
    onClick,
    options = { size: 35, showPresence: true, togglePresence: false },
    presence: presenceProp,
}) => {
    const socketService = useSocketService()
    const [status, setStatus] = useState<string>('')
    const [avatar, setAvatar] = useState<string>('')

    const currentStatus = presenceProp || status

    useEffect(() => {
        if (options?.togglePresence && !presenceProp) {
            kedo.api()
                .get(kedo.api().getUserProfileEndpoint('me'))
                .then((result) => {
                    if (
                        result.data &&
                        result.data.private_settings &&
                        result.data.private_settings.presence
                    ) {
                        const saved = result.data.private_settings.presence
                        socketService.user
                            .setPresence(saved)
                            .then((resultPresence: string) => {
                                setStatus(
                                    (typeof resultPresence === 'string' &&
                                        resultPresence) ||
                                        saved
                                )
                            })
                            .catch(() => setStatus(saved))
                    }
                })
                .catch((errResponse) => console.log(errResponse))
        }
    }, [])

    useEffect(() => {
        if (presenceProp) {
            return
        }

        const fromSocket = socketService.user.getPresence(user.userId as number)

        setStatus((fromSocket as unknown as string) || '')
    }, [
        user.userId,
        presenceProp,
        socketService,
        socketService.presenceRevision,
    ])

    const presence = (value: string): string => {
        switch (value) {
            case 'online':
                return 'green'
            case 'busy':
                return 'red'
            case 'away':
                return 'orange'
            case 'invisible':
                return 'gray'
            default:
                return 'unset'
        }
    }

    const fetchAvatar = () => {
        kedo.api()
            .getCached(kedo.api().getUserEndpoint(user.userId))
            .then((response) => {
                setAvatar(
                    response.data && response.data.avatar?.length > 0
                        ? kedo
                              .api()
                              .getUserAvatarEndpoint(
                                  user.userId,
                                  response.data.avatar
                              )
                        : ''
                )
            })
            .catch(() => {
                // soft-fail (e.g. 403): keep initials / default logo
            })
    }

    useEffect(() => {
        fetchAvatar()
    }, [user])

    return (
        <Box
            className="avatar-online"
            onClick={onClick}
            sx={{ cursor: onClick ? 'pointer' : 'default' }}
        >
            <ReactAvatar
                name={`${user.username}`}
                round={true}
                value="40%"
                size={options?.size || 35}
                src={avatar || (!user?.username ? logo : undefined)}
            />

            {options?.showPresence &&
                kedo.env() &&
                kedo.env().hasEnviroment() && (
                    <FontAwesomeIcon
                        style={{
                            color: presence(currentStatus),
                            top:
                                options?.size && options.size <= 26
                                    ? '16px'
                                    : '22px',
                            left:
                                options?.size && options.size <= 26
                                    ? '16px'
                                    : '22px',
                        }}
                        icon={faCircle}
                    />
                )}
        </Box>
    )
}

export default Avatar
